import { changePassword, generateLocalToken, resetPassword } from "../service/authServie";

let SiteId=window?.Liferay?.ThemeDisplay?.getSiteGroupId()
let domainName = window.location.origin
let client_ID;
let client_Secret;
let token=window?.Liferay?.authToken;
let isDevelopment;

(async function setConstants () {
  let currentDomain = window.location.hostname
  isDevelopment = false


 switch (true) {
    case currentDomain.includes('dev'):

      client_ID = 'id-686b61b3-fe38-4395-8db6-c7d1f41a6ec1'
      client_Secret = 'secret-93dac2f3-548d-1685-198a-b838e4c1b2'
      break
     case currentDomain.includes('uat'):
        case currentDomain.includes('hayak-uat.dafz.ae'):
          case currentDomain.includes('newuat.diez.ae'):
      client_ID = 'id-6dd9ef97-af29-c59d-934a-4a99f8bfbf4'
      client_Secret = 'secret-b3acca8e-9255-3f81-b3c6-431fdeaa071'
      break
    case currentDomain.includes('prd'):
   case currentDomain.includes('hayak.dafz.ae'):
      client_ID = 'id-9ccbed5c-17a6-1036-1e55-5bb78fa82457'
      client_Secret = 'secret-9c2ccaac-0b3e-050e-91f6-b42f75e78be'
      break
    case currentDomain.includes('localhost'):
      SiteId = '539712'
      client_ID = 'id-686b61b3-fe38-4395-8db6-c7d1f41a6ec1'
      client_Secret = 'secret-93dac2f3-548d-1685-198a-b838e4c1b2'
      isDevelopment = true
      domainName='https://hayak-dev.dafz.ae'
      break
    default:
      console.log('Unknown environment')
      break
  }
})()
export const Constants = {
  URL: {
    base: `${domainName}`,
    auth: '/o/oauth2/token',
    verifyResetOtp:'/o/hayak-custom-headless/v1.0/hayak/verify-user-otp',
    changePassword: '/o/hayak-custom-headless/v1.0/hayak/update-password',
    resetPassword: "/o/hayak-custom-headless/v1.0/hayak/reset-password",
    brandsAttachmentUrl:'/o/c/brandattachments',
    brandsUrl: `o/hayak-custom-headless/v1.0/hayak/get-brand-list`,
    brandDetail:`o/hayak-custom-headless/v1.0/hayak/get-brandId`,
    domains: `/o/dcc-custom-headless/v1.0/dcc/partner-management-system/get-domain-and-services/${SiteId}`,
    upload: `/o/headless-delivery/v1.0/sites/${SiteId}/documents?restrictFields=actions,documentType,adaptedImages,contentUrl,keywords,numberOfComments,relatedContents,renderedContents,taxonomyCategoryBriefs,siteId,externalReferenceCode,encodingFormat,documentFolderId,description,dateModified,dateCreated,creator,customFields,sizeInBytes`,
    migrateUserlogin:
      `/o/hayak-custom-headless/v1.0/hayak/migrate-user-login`,
      createMigreatedUser:"/o/hayak-custom-headless/v1.0/hayak/check-and-create-member-user",
      updateBrand:
      `/o/hayak-custom-headless/v1.0/hayak/update-brand`,
    verifyUserEmail: '/o/hayak-custom-headless/v1.0/hayak/verify-user-email-send-otp',
    getApplications: `/o/c/partneronboardings/`,
    getApplicationById:
      '/o/dcc-custom-headless/v1.0/dcc/partner-management-system/get-onboarding-data',
    acceptApplication: '/o/c/partneronboardings/',
    onboardPartner:
      '/o/dcc-custom-headless/v1.0/dcc/partner-management-system/onboard-partner/',
    applicationCounts:
      '/o/dcc-custom-headless/v1.0/dcc/partner-management-system/get-applications-counts',
    applicationLogs: `o/c/partneronboardings/`,
    login: '/o/hayak-custom-headless/v1.0/hayak/verify-user-email-send-otp',
    verify: '/o/hayak-custom-headless/v1.0/hayak/varify-user-otp',
    checkSession:
      '/o/dcc-custom-headless/v1.0/dcc/partner-management-system/get-session-info',
    countryMobileCode: 'https://restcountries.com/v3.1/all?fields=id,name',
    leadsList: `/o/c/leads/scopes/${SiteId}`,
    shareMSAWithDocuSign:
      '/o/dcc-custom-headless/v1.0/dcc/partner-management-system/send-for-docusign/',
    getLeadById: `o/dcc-custom-headless/v1.0/dcc/lead-management-system/get-lead-details`,
    shareQuoationByEmail: `o/dcc-custom-headless/v1.0/dcc/lead-management-system/share-quotation`,
    leadManagementSystem: `o/dcc-custom-headless/v1.0/dcc/lead-management-system`,
    acceptQuoation: `o/dcc-custom-headless/v1.0/dcc/lead-management-system/accept-quotation`,
    leadsUrl: `o/c/leads/`,
    leadsUpdateStatus: `o/c/leads/`,
    partnerLead: `/o/c/partnerleads/`,
    deleteDocumentUrl: '/o/c/additionaldocuments/',
    shareMSA:
      '/o/dcc-custom-headless/v1.0/dcc/partner-management-system/share-msa',
    partnersList: `/o/c/partnerses/`,
    shareLeadWithPartners: `/o/dcc-custom-headless/v1.0/dcc/lead-management-system/assign-lead`,
    projectList: `/o/c/projects/`,
    checkemiratesID:
      '/o/hayak-custom-headless/v1.0/hayak/check-UserEmrit-id',
    requestInvoice: '/o/c/milestoneses',
    logMilestone:
      '/o/dcc-custom-headless/v1.0/dcc/lead-management-system/log-milestones',
    payoutById: '/o/c/payouts/',
    dahboardApi:
      '/o/dcc-custom-headless/v1.0/dcc/partner-management-system/get-dcc-dashboard',
    PartnerDashboardApi:
      '/o/dcc-custom-headless/v1.0/dcc/partner-management-system/get-partner-dashboard',
    PartnerdetailsById:
      '/o/dcc-custom-headless/v1.0/dcc/partner-management-system/get-partner-details',
    teamList: '/o/c/teammembers',
    addTeamMember:
      '/o/dcc-custom-headless/v1.0/dcc/lead-management-system/add-team-member',
    editTeamMember:
      '/o/dcc-custom-headless/v1.0/dcc/team-management-system/modify-team-member/',
    getTeamDetails:
      '/o/dcc-custom-headless/v1.0/dcc/team-management-system/get-member-details/',
    onboardingMIS:
      '/o/dcc-custom-headless/v1.0/dcc/partner-management-system/get-onboarding-report',
    leadsMIS:
      '/o/dcc-custom-headless/v1.0/dcc/partner-management-system/get-lead-report',
    projectMIS:
      '/o/dcc-custom-headless/v1.0/dcc/partner-management-system/get-project-report',
    createLead:
      '/o/dcc-custom-headless/v1.0/dcc/lead-management-system/create-lead'
  },

  publicPath: {
    localServer: 'images/',
    productionServer: '/documents/d/partner-management-system/'
  },
  client: {
    id: client_ID,
    secret: client_Secret
  },
  isDevelopment
}

export const StatusBadges = {
  Active: 'btn-green',
  In_Active :'btn-red',
  Draft :"btn-dark"

}




export const StatusBadgesProject = {
  CREATED: 'badge-default',
  HOLD: 'badge-lime',
  COMPLETED: 'badge-lime',
  IN_PROGRESS: 'badge-green',
  CANCELLED: 'badge-red'
}

export const BrandStatus = {
  Active: 'Active',
  In_Active: 'In Active',
   Draft: 'Draft'
}

export const StatusBadgesGradient = {
  SUBMITTED: 'badge-purple-gradient',
  submitted: 'badge-purple-gradient',
  IN_REVIEW: 'badge-lime',
  ACCEPTED: 'badge-green',
  AGREEMENT: 'badge-green',
  ONBOARDED: 'badge-green',
  ASSIGNED: 'badge-default',
  NEGOTIATION: 'bg-gradient-warning',
  DECLINED: 'badge-red-gradient',
  CLOSED_WON: 'badge-green-gradient'
}

export const applicationStatus = {
  SUBMITTED: 'New',
  submitted: 'New',
  IN_REVIEW: 'Under Review',
  ACCEPTED: 'Agreement',
  DECLINED: 'Declined',
  AGREEMENT: 'Agreement',
  ONBOARDED: 'Onboarded'
}


export const leadStatusMap = {
  SUBMITTED: 'New',
  DECLINED: 'Declined',
  AGREEMENT: 'Agreement',
  QUALIFIED: 'Qualified',
  ASSIGNED: 'Assigned',
  QUOTATION: 'Quotation',
  NEGOTIATION: 'Negotiation',
  CLOSED_WON: 'Closed: won',
  CLOSED_LOST: 'Closed: lost'
}
export const PartnerleadStatusMap = {
  ASSIGNED: 'New',
  IN_REVIEW: 'Under Review',
  ACCEPTED: 'Agreement',
  DECLINED: 'Declined',
  AGREEMENT: 'Agreement',
  NEGOTIATION: 'Negotiation',
  ONBOARDED: 'Onboarded',
  QUOTATION: 'Quotation',
  CLOSED_LOST: 'Closed :Lost',
  CLOSED_WON: 'Closed :Won'
}

export const RequiredDocuments = [
  {
    name: 'Copy of valid incorporation certificate',
    id: 'copyOfValidIncorporationCertificate',
    mandatory: true,
    docId: '',
    url: ''
  },
  {
    name: 'Copy of valid UAE license',
    id: 'copyOfValidUAELicense',
    mandatory: true,
    docId: '',
    url: ''
  },
  {
    name: 'Signed NDA',
    id: 'signedNDA',
    mandatory: false,
    docId: '',
    url: ''
  },
  {
    name: 'Registration application form for audit firms',
    id: 'registrationApplicationFormForAuditFirms',
    mandatory: false,
    docId: '',
    url: ''
  },
  {
    name: 'CV/staff profile documents',
    id: 'cVStaffProfileDocuments',
    mandatory: false,
    docId: '',
    url: ''
  },

  {
    name: 'Affiliation certificate with international firm',
    id: 'affiliationCertificateInternationalFirm',
    mandatory: false,
    docId: '',
    url: ''
  },
  {
    name: 'Proof of registration with other freezones',
    id: 'proofOfRegistrationWithOtherFreezones',
    mandatory: false,
    docId: '',
    url: ''
  },
  {
    name: 'Proof of registration with UAE banks',
    id: 'proofOfRegistrationWithUAEBanks',
    mandatory: false,
    docId: '',
    url: ''
  }
]

export const AuditServices = [
  { name: 'Accounting & Financial Management', id: '751796' }
]


export const BrandColor = [
  { id: 'tab1', label: 'Without background color' },
  { id: 'tab2', label: 'With color'}
];

export const RequiredDocumentsID = {
  auditID: 'registrationApplicationFormForAuditFirms'
}

export const Undertakings = [
  {
    id: 'undertakingOne',
    title: 'I hereby declare that the information provided in this application form is true, accurate, and complete to the best of my knowledge and belief. I understand that any false or misleading information provided, or the omission of any relevant information, may result in the rejection of my application or other appropriate actions as deemed necessary by Dubai CommerCity.',
    checked: false,
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed porttitor, quam id luctus molestie, lectus dui ornare risus, eget venenatis felis libero sit amet eros. Praesent pretium, turpis vel vulputate consequat, nulla diam hendrerit enim, vel pretium leo nulla non mauris. Sed porta magna vel pharetra cursus. Nunc consequat non nisi fermentum tristique. Vestibulum quis tortor purus. Integer sit amet augue gravida odio vulputate ultricies sit amet non enim. Sed viverra ex ac turpis finibus scelerisque. Donec a dapibus mauris. Aenean suscipit lorem ac lobortis sollicitudin. Sed ornare molestie felis id mollis. Cras sit amet dapibus est, et convallis leo. Suspendisse tristique justo accumsan nulla maximus, id bibendum tortor ultrices. Morbi non ipsum mollis, vestibulum purus sed, laoreet turpis.

        Praesent sodales quam ante, id feugiat tellus rhoncus et. Nunc et urna nulla. In fermentum sed mi ac dapibus. Nullam ullamcorper ut velit ac maximus. Nulla facilisi. Nulla ullamcorper, erat vel facilisis sodales, ex ipsum cursus nibh, ac suscipit est dolor nec quam. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus sit amet lacus ultricies, vestibulum quam vel, vestibulum nunc. Aliquam molestie scelerisque nisi, id venenatis leo sagittis sit amet. Nulla hendrerit, ex sed rutrum venenatis, metus dolor dictum ipsum, et posuere quam ligula quis mauris.
        
        Aenean malesuada facilisis condimentum. Etiam feugiat massa id porttitor bibendum. Nam sed libero porta leo sagittis pulvinar a dapibus felis. Mauris dignissim, sem et lobortis aliquam, felis sapien vestibulum odio, et sollicitudin leo diam non elit. Mauris et molestie odio. Donec ut tincidunt nibh. Proin dictum placerat pellentesque. Nam sollicitudin lacus purus, et iaculis ex imperdiet euismod. Integer imperdiet, mauris ac facilisis faucibus, ipsum odio hendrerit justo, ut pulvinar eros ex id tellus. Nam commodo, metus ut varius tristique, nunc neque faucibus libero, vel ornare diam tortor a metus. Suspendisse tincidunt quis leo et pretium. Pellentesque nec interdum nulla, eleifend pretium lorem. Maecenas finibus mauris in laoreet pretium.
        
        Maecenas eget malesuada sem. In hac habitasse platea dictumst. Aliquam rhoncus dui eu consequat mollis. Aliquam imperdiet quis nisi non mattis. Cras egestas mi eu ipsum molestie facilisis. Sed volutpat viverra orci, vel aliquet ante porttitor id. Integer quis nisl ac nulla blandit malesuada. Donec eros massa, pretium at mollis eu, laoreet eget tortor.
        
        Nam dictum nibh sem, non congue augue euismod in. Aliquam sollicitudin et neque nec facilisis. Vivamus gravida aliquam nisi nec posuere. Quisque suscipit nec ligula ut luctus. Phasellus vel dolor dapibus, tristique risus ac, aliquam felis. Sed fermentum id turpis a consequat. Quisque sed cursus enim, in sollicitudin purus. In eget commodo enim. Vestibulum eleifend et nisi vitae tristique. Suspendisse ut elit vulputate, vulputate augue at, congue mauris. Vivamus molestie metus vitae ligula dictum, sit amet cursus nunc convallis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.`
  }
]

export const StatusLeadBadges = {
  NEW: 'badge-default',
  QUALIFY: 'badge-yellow',
  ASSIGNED: 'badge-blue',
  QUALIFIED: 'badge-blue',
  DISQUALIFIED: 'badge-red',
  CLOSED_LOST: 'badge-red',
  CLOSED_WON: 'badge-green'
}

export const LeadStatusList = {
  NEW: 'New',
  QUALIFY: 'Qualify',
  QUALIFIED: 'Qualified',
  DISQUALIFIED: 'Disqualified',
  ASSIGNED: 'Assigned',
  QUOTATION: 'Quotation',
  CLOSED_LOST: 'Closed: Lost',
  CLOSED_WON: 'Closed: Won',
  NEGOTIATION: 'Negotiation',
  DECLINED: 'Declined'
}

export const CommisionTypes = {
  revenue: 'Revenue Shared',
  backtoback: 'Back to back'
}

// ---------------



export const businessUnits = ['DAFZ', 'DCC', 'DIEZ', 'DSO', 'DAFZ Client']

